var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4639 14.4788L11.177 11.1778C12.0221 10.2076 12.4851 8.98704 12.4851 7.71635C12.4851 4.74748 9.98372 2.33203 6.90919 2.33203C3.83467 2.33203 1.33325 4.74748 1.33325 7.71635C1.33325 10.6852 3.83467 13.1007 6.90919 13.1007C8.06341 13.1007 9.16332 12.7645 10.1037 12.1263L13.4156 15.4524C13.554 15.5913 13.7402 15.6678 13.9397 15.6678C14.1286 15.6678 14.3077 15.5983 14.4437 15.4719C14.7327 15.2034 14.7419 14.7581 14.4639 14.4788ZM6.90919 3.73663C9.18175 3.73663 11.0305 5.52189 11.0305 7.71635C11.0305 9.9108 9.18175 11.6961 6.90919 11.6961C4.63663 11.6961 2.78784 9.9108 2.78784 7.71635C2.78784 5.52189 4.63663 3.73663 6.90919 3.73663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.676bab4ce96115e142f5e9db3025f6df.svg";
export { ForwardRef as ReactComponent };